import { useEffect, useState } from 'react';
import { PercentageSlider } from '../../../../../../components/UI-Elements/Sliders/PercentageSlider';
import { priceMockData } from '../../DueDateCalendar/DuoDateComponents/DuoDateMockData';
import { DuoDateQuantityCalendar } from '../../DueDateCalendar/DuoDateComponents/DuoDateQuantityCalendar';
import { ClientOrderQuote, clientOrderAdditionalProps } from '../../../../../../sp-types/clientOrderQuoteType';
import { MonthYearValue } from '../../../../../../utils/MonthYear/MonthYearValue';
import React from 'react';

interface Props {
  clientOrder: ClientOrderQuote;
  updateClientOrder: <K extends keyof ClientOrderQuote>(prop: K, value: ClientOrderQuote[K]) => void;
  updateParentState: boolean;
  setUpdateParentState: (set: boolean) => void;
}

export const ClientOrderRefineQuote: React.FC<Props> = ({
  clientOrder,
  updateClientOrder,
  setUpdateParentState,
  updateParentState,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(Array(2).fill(''));
  const [downPayments, setDownPayments] = useState(clientOrder.downPayments || 0);
  const [changes, setChanges] = useState<clientOrderAdditionalProps>();
  const [cancellation, setCancellation] = useState<clientOrderAdditionalProps>();
  const [priceCalender, setPriceCalendar] = useState<MonthYearValue[]>(clientOrder.priceCalendar || []);
  const [adding] = useState(5); // Need to be passed
  const [BasicPrice] = useState(925); // Need to be passed
  const [addedPrice] = useState((BasicPrice * adding) / 100); // Need to be passed
  const [adjustedPrice] = useState(BasicPrice + addedPrice); // Need to be passed
  const [totalPrice] = useState(adjustedPrice * clientOrder.quantity); // Need to be passed

  useEffect(() => {
    if (updateParentState) {
      downPayments && updateClientOrder('downPayments', downPayments);
      cancellation && updateClientOrder('cancellationFee', cancellation);
      changes && updateClientOrder('changesFee', changes);
      priceCalender && updateClientOrder('priceCalendar', priceCalender);
      setUpdateParentState(false);
    }
  }, [updateParentState]);

  type componentTextFields = {
    title: string;
    value: string;
    color?: string;
  };

  type optionDetailsComponentField = {
    title: string;
    description: string;
    options: clientOrderAdditionalProps[];
    onChange: (data: clientOrderAdditionalProps) => void;
  };

  // Need to get those options from other place
  const additionalDetailsInputFields: optionDetailsComponentField[] = [
    {
      title: 'Changes',
      description: 'When a client wants to change the contract terms',
      options: [
        { label: 'No change  ', value: 0 },
        { label: 'One Change  ', value: 5 },
        { label: 'Few changes  ', value: 10 },
      ],
      onChange: setChanges,
    },
    {
      title: 'Cancellation',
      description: 'When a client wants to cancel the contract',
      options: [
        { label: 'No cancellation ', value: 0 },
        { label: 'Partial cancellation ', value: 5 },
        { label: 'Full cancellation ', value: 15 },
      ],
      onChange: setCancellation,
    },
  ];

  const handleSelectChange = (itemIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[itemIndex] = event.target.value;
    setSelectedOptions(newSelectedOptions);

    const selectedOption = additionalDetailsInputFields[itemIndex].options.find(
      (option) => option.label === event.target.value,
    );
    if (selectedOption) {
      additionalDetailsInputFields[itemIndex].onChange(selectedOption);
    }
  };

  const priceFields: componentTextFields[] = [
    { title: 'Basic price (unit)', value: `$${BasicPrice}`, color: 'black' },
    { title: 'Adding', value: `+${adding}%`, color: 'black' },
    { title: 'USD', value: `$${addedPrice.toFixed()}`, color: 'red' },
    { title: 'Adjusted price', value: `$${adjustedPrice.toFixed()}`, color: 'red' },
    { title: 'Quantity', value: `$${clientOrder.quantity}`, color: 'black' },
    { title: 'Total expected price', value: `$${totalPrice.toFixed()}`, color: 'red' },
  ];

  // I can use it to disable update when not wanted
  const updatePriceCalendar = (data: MonthYearValue[]) => {
    setPriceCalendar(data);
  };

  return (
    <div className="flex flex-col h-full ">
      <div className="flex flex-col ">
        <div className="flex flex-wrap space-x-[2rem] mt-[1.5rem] mb-[1.5rem] ">
          {priceFields.map((item, index) => (
            <div key={index}>
              <p className="mb-[0.25rem] text-sm text-secondary_text">{item.title}</p>
              <p className={`text-${item.color}`}>{item.value}</p>
            </div>
          ))}
        </div>
        <div className="flex border-t-2 border-gray-100 h-[1rem]  "></div>
      </div>
      <div className="flex flex-col grow mt-[1rem] mb-[2rem]">
        <div className="flex basis-1/2 justify-between">
          <div className="max-w-[13.5rem]">
            <p className="text-lg text-black mb-[0.375rem]"> Down payments</p>
            <p className="text-sm text-secondary_text mb-[0.375rem]">This section lets you set the payment terms</p>
            <div className="mt-[1.25rem]">
              <PercentageSlider setValue={setDownPayments} value={downPayments} />
            </div>
          </div>
          {additionalDetailsInputFields.map((item, index) => (
            <div className="max-w-[13.5rem]" key={index}>
              <p className="text-lg text-black mb-[0.375rem]">{item.title} </p>
              <p className="text-sm text-secondary_text mb-[0.375rem]">{item.description}</p>
              <select
                value={selectedOptions[index]}
                title={item.title}
                className="select order-1 rounded border-gray-450 px-[0.5rem] mt-[1.25rem] py-[0.25rem] w-full"
                onChange={(e) => handleSelectChange(index, e)}
              >
                <option value="" disabled hidden>
                  Select an option
                </option>{' '}
                {item.options.map((option, idx) => (
                  <option key={idx} value={option.label}>
                    {option.label + option.value + '%'}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>
        <div className="flex flex-col grow min-h-[18rem]">
          <div className="text-lg py-[1.25rem] border-t-2 border-gray-100">Monthly delivery</div>
          <div className="relative flex-grow">
            <div className="absolute left-0 right-0 top-0 bottom-0 overflow-x-auto ">
              <div className="min-w-[48rem]">
                <DuoDateQuantityCalendar
                  priceCalendar={priceCalender}
                  setPriceCalendar={updatePriceCalendar}
                  duoDate={clientOrder.DueDate!}
                  quantity={clientOrder.quantity}
                  pricePerTonData={priceMockData}
                  singleYearView={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
